export class LoginData 
{
    userid : number;
    username :string;
    password: any;
}
